export const HEADER_HEIGHT = 71;
export const MOBILE_NAV_WIDTH = 500;
export const DROPDOWN_MAX_WIDTH = 1500;
export const HIGHLIGHTED_SECTION_WIDTH = 1100;
export const DROPDOWN_OFFSET = 26;
